/* eslint-disable sort-keys-fix/sort-keys-fix */
export const BREAKPOINTS = {
  XXS: 320,
  XS: 375,
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
};

export const HEADER_MOBILE_BREAKPOINT = BREAKPOINTS.LG;
export const MATRIX_TABLET_BREAKPOINT = BREAKPOINTS.LG;
export const MATRIX_MOBILE_BREAKPOINT = BREAKPOINTS.SM;
export const MOBILE_PDM_BREAKPOINT = 460;
